import { render } from "./ResetProjectAndBiosampleStatuses.vue?vue&type=template&id=8f82112c&scoped=true"
import script from "./ResetProjectAndBiosampleStatuses.vue?vue&type=script&lang=js"
export * from "./ResetProjectAndBiosampleStatuses.vue?vue&type=script&lang=js"

import "./ResetProjectAndBiosampleStatuses.vue?vue&type=style&index=0&id=8f82112c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1847379700/src/basejumper-amplify/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f82112c"]])

export default __exports__